/* ==========================================================================
   AutocompleteRxjs > Client > Helpers > Data
   ========================================================================== */

/* Modules */
const { groupBy } = require('../../../../../helpers/array');

/**
 * Group by type a collection of objects
 * @param {array} collection of objects
 * @return {set} grouped collection
 */
function groupByType(collection) {
    if (collection.length < 1) return collection;

    return groupBy(
        collection.map((item, index) => ({ ...item, index })),
        item => item.type
    );
}

/**
 * Collection by group
 * Transforms a collection into the same 2 dimensional grouped by types
 * @
 */
function collectionByGroup(collection) {
    if (collection.length < 1) return collection;

    const grouped = groupByType(collection);

    return [...grouped.keys()].map(key => ({ key, suggestions: grouped.get(key) }));
}

/* Exports */
module.exports = {
    collectionByGroup
};
